import React, { useCallback } from "react";
import { ArrowDownIcon, ArrowUpIcon, Icon, Table } from "evergreen-ui";

const DataTableHead = ({ columns, onColumnClick, sortColumn, sortInverse }) => {
  const getSortIcon = (column) => {
    return sortColumn && sortColumn === column ? (
      <Icon
        icon={!sortInverse ? ArrowUpIcon : ArrowDownIcon}
        marginLeft={4}
        size={12}
      />
    ) : null;
  };

  const handleColumnClick = useCallback(
    (column) => () => {
      onColumnClick(column);
    },
    [onColumnClick]
  );

  return (
    <Table.Head>
      {columns.map((column, index) => {
        const headerCellProps = {
          flex: column.flex || "1",
          textAlign: column.align,
        };
        return (
          <Table.TextHeaderCell
            {...headerCellProps}
            cursor="pointer"
            key={`DataTable-Header-${index}`}
            onClick={handleColumnClick(column)}
          >
            {column.name}
            {getSortIcon(column)}
          </Table.TextHeaderCell>
        );
      })}
    </Table.Head>
  );
};

export default DataTableHead;
